export function useProcessEnv() {
  return {
    isProduction: process.env.CLIENT_ENV === 'production',
  }
}
